/** 与 backend userPresence.js DEFAULT_ONLINE_WINDOW_MINUTES 一致 */
export const ONLINE_WINDOW_MINUTES = 10;
export const HEARTBEAT_INTERVAL_MS = 2 * 60 * 1000;
export const ADMIN_ONLINE_POLL_MS = 30 * 1000;

export function formatRelativeActive(lastSeenAt: string, now = Date.now()): string {
  const t = new Date(lastSeenAt).getTime();
  if (Number.isNaN(t)) return '—';
  const diffSec = Math.max(0, Math.floor((now - t) / 1000));
  if (diffSec < 45) return '刚刚';
  if (diffSec < 60) return '不到 1 分钟';
  const diffMin = Math.floor(diffSec / 60);
  if (diffMin < ONLINE_WINDOW_MINUTES) return `${diffMin} 分钟前`;
  return '较久前';
}

export function activeHeatClass(lastSeenAt: string, now = Date.now()): string {
  const t = new Date(lastSeenAt).getTime();
  if (Number.isNaN(t)) return 'admin-online-heat--dim';
  const diffSec = (now - t) / 1000;
  if (diffSec < 60) return 'admin-online-heat--hot';
  if (diffSec < 180) return 'admin-online-heat--warm';
  if (diffSec < 600) return 'admin-online-heat--cool';
  return 'admin-online-heat--dim';
}

export function roleLabel(role: string): string {
  if (role === 'super_admin') return '超级管理员';
  if (role === 'admin') return '管理员';
  if (role === 'investor') return '投资人';
  return '创作者';
}
